// node_modules
import { FC, useEffect, useState } from "react";
// Types
import { TSideNoteDTO, TTechnology } from "Types";
// Components
import { SideNoteList } from "Components/Shared";
// Enums
import { EntityTypeEnum } from "Enums";
// styles
import styles from "./technologySideNotesModal.module.scss";

type TTechnologySideNotesModalProps = {
    technology: TTechnology,
    handleOnMouseEnterModal: () => void,
    handleOnMouseLeaveModal: () => void
}

export const TechnologySideNotesModal: FC<TTechnologySideNotesModalProps> = ({ technology, handleOnMouseEnterModal, handleOnMouseLeaveModal }: TTechnologySideNotesModalProps) => {
    // State
    const [technologySideNotes, setTechnologySideNotes] = useState<TSideNoteDTO[]>([]);

    // Logic
    useEffect(() => {
        if (technology.sideNotes.length >= 1) {
            setTechnologySideNotes(technology.sideNotes);
        } else {
            setTechnologySideNotes([]);
        }
    }, [technology, technology.sideNotes]);

    return (
        <div onMouseEnter={handleOnMouseEnterModal} onMouseLeave={handleOnMouseLeaveModal} className={[styles.technologySideNotesModal, styles.scrollbarCustomThin].join(" ")}>
            {technologySideNotes && technologySideNotes.length >= 1 ?
                <SideNoteList extraClassName={styles.inSideNotesModal} sideNotes={technologySideNotes} entityType={EntityTypeEnum.TechnologyType}
                    entityId={technology.id} isReplyable={false} />
                : <></>
            }
        </div>
    );
}